import { IResourceAggregateCriteria } from '@agoda/performance-client';
import { AppConfiguration } from 'core/configuration/AppConfiguration';

export const resourceAggregates = (): IResourceAggregateCriteria[] => {
    const isDevEnv = AppConfiguration.isDev();
    return [
        {
            metric: 'SCRIPT',
            initiatorType: ['script', 'link'],
            urlPattern: isDevEnv ? /\/.*\.js/i : /\/assets\/.*\.js/i,
        },
        {
            metric: 'IMG',
            initiatorType: ['img'],
            urlPattern: /\/images\/(\d+|\S+)\//i,
        },
        {
            metric: 'FONT',
            initiatorType: ['css', 'other'],
            urlPattern: /cdn\d*\..*\/fonts.*\.(eot|woff2?|ttf|svg)/gi,
        },
        {
            metric: 'DATA',
            initiatorType: ['xhr', 'xmlhttprequest'],
            urlPattern: /\/api\/cronos\//i,
        },
        {
            metric: 'GQL',
            initiatorType: ['xhr', 'fetch'],
            urlPattern: /\/graphql/i,
        },
        {
            metric: 'STYLE',
            initiatorType: ['css', 'link'],
            urlPattern: isDevEnv ? /\/.*\.css/i : /\/assets\/.*\.css/i,
        },
    ];
};
